import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getClassNameFactory, getRehydratableName } from "../../utilities";
import DropdownItem from "./DropdownItem";
import DropdownHeader from "./DropdownHeader";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import CrossIcon from "@dcl/icons/esm/ui/cross";
import classNames from "classnames";
import rehydrator from "./Dropdown.rehydrator";
import { BASE_FONT_SIZE } from "./DropdownConstants";
import uniqueId from "lodash/uniqueId";

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "ulRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "toggleButtonRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "selectedLinkRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "filterContainerRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "inputRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      id: _this.props.id || uniqueId("dropdown-"),
      expanded: false,
      value: _this.props.value || "",
      index: 0,
      maxListHeight: "0",
      // to prevent blinking in firefox
      filteredItems: _this.props.items,
      isClearButtonVisible: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.items !== _this.props.items) {
        _this.setState({
          filteredItems: _this.props.items
        });
      }

      if (_this.state.expanded && _this.ulRef.current) {
        _this.ulRef.current.focus();
      }

      if (_this.inputRef && _this.isTypeaheadMode) {
        if (_this.props.removeAutoFocus && _this.state.expanded || !_this.props.removeAutoFocus) {
          _this.inputRef.current.focus();
        }

        return;
      }

      if (!_this.state.expanded || !_this.selectedLinkRef.current) {
        return;
      }

      _this.selectedLinkRef.current.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Dropdown.displayName));

    _defineProperty(_assertThisInitialized(_this), "expandButtonId", uniqueId("expand-button-"));

    _defineProperty(_assertThisInitialized(_this), "filterInputId", uniqueId("filter-input-id-"));

    _defineProperty(_assertThisInitialized(_this), "renderTypeahead", function () {
      var Filter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
        var inputId = _ref.inputId,
            setValue = _ref.setValue,
            value = _ref.value;

        var handleChange = function handleChange(event) {
          setValue({
            value: event.target.value
          });

          if (!_this.state.expanded) {
            _this.expand();

            _this.setState({
              index: -1
            });
          }

          _this.handleFilter(event.target.value);

          _this.setState({
            isClearButtonVisible: Boolean(event.target.value)
          });

          if (_this.props.onFilterValueChanged) {
            _this.props.onFilterValueChanged(event.target.value);
          }
        };

        var handleClick = function handleClick(event) {
          _this.toggleExpand();

          _this.setState({
            index: -1
          });

          event.target.focus();
        };

        var handleClear = function handleClear() {
          _this.expand();

          _this.setState({
            index: -1,
            value: "",
            isClearButtonVisible: false
          });

          _this.handleFilter("");

          if (_this.props.onClearButtonClick) {
            _this.props.onClearButtonClick();
          }
        };

        var handleKeyDownFilter = function handleKeyDownFilter(e) {
          if (e.key === "Enter" || e.key === " ") {
            handleClear();
          }
        };

        return /*#__PURE__*/React.createElement("div", {
          role: "button",
          ref: ref,
          onClick: handleClick,
          onKeyDown: _this.onKeyDown,
          className: _this.getClassName({
            descendantName: "filter"
          })
        }, /*#__PURE__*/React.createElement("input", {
          className: _this.getClassName({
            descendantName: "filterInput"
          }),
          ref: _this.inputRef,
          placeholder: _this.props.placeholder,
          id: inputId,
          onChange: handleChange,
          autoComplete: "off",
          type: "text",
          value: value
        }), /*#__PURE__*/React.createElement("div", {
          className: _this.getClassName({
            descendantName: "buttons"
          })
        }, _this.state.isClearButtonVisible && /*#__PURE__*/React.createElement("div", {
          className: _this.getClassName({
            descendantName: "clearButton"
          }),
          onClick: handleClear,
          tabIndex: 0,
          "aria-label": _this.props.clearButtonLabel,
          role: "button",
          onKeyDown: handleKeyDownFilter
        }, /*#__PURE__*/React.createElement("div", {
          className: _this.getClassName({
            descendantName: "clearIcon"
          })
        }, /*#__PURE__*/React.createElement(CrossIcon, null))), /*#__PURE__*/React.createElement("div", {
          className: _this.getClassName({
            descendantName: "filterButton"
          })
        }, /*#__PURE__*/React.createElement("span", {
          className: _this.getClassName({
            descendantName: "filterIcon"
          })
        }, /*#__PURE__*/React.createElement(ChevronDownIcon, null)))));
      });
      Filter.displayName = "Filter";

      var renderInput = function renderInput(containerRef, inputId) {
        return /*#__PURE__*/React.createElement(Filter, {
          inputId: inputId,
          value: _this.state.value,
          ref: containerRef,
          setValue: _this.setState.bind(_assertThisInitialized(_this))
        });
      };

      return renderInput(_this.filterContainerRef, _this.filterInputId);
    });

    _defineProperty(_assertThisInitialized(_this), "collapse", function () {
      _this.setState({
        expanded: false
      });

      if (_this.props.onDropdownBlur) {
        _this.props.onDropdownBlur();
      }

      if (_this.toggleButtonRef && _this.toggleButtonRef.current) {
        _this.toggleButtonRef.current.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "expand", function () {
      if (_this.inputRef && _this.isTypeaheadMode) {
        _this.setState({
          expanded: true
        });

        _this.inputRef.current.focus();
      }

      var _this$props$items = _this.props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items;

      _this.setState(function (_ref2) {
        var value = _ref2.value;
        var index = items.findIndex(function (item) {
          return item.value === value;
        });
        return {
          expanded: true,
          index: index === -1 ? 0 : index
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleExpand", function () {
      if (_this.state.expanded) {
        _this.collapse();
      } else {
        _this.expand();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "maybeCollapse", function (event) {
      if (!_this.state.expanded) {
        return;
      } // document.activeElement is IE11 fallback


      var relatedTarget = event.relatedTarget || document.activeElement;

      if (relatedTarget === _this.ulRef.current || relatedTarget.id === _this.expandButtonId) {
        return;
      }

      var filterContainer = _this.filterContainerRef.current;

      if (filterContainer && filterContainer.contains(relatedTarget)) {
        return;
      }

      if (typeof event === "undefined" || typeof relatedTarget === "undefined" || relatedTarget === null || relatedTarget.className.indexOf(_this.getClassName({
        descendantName: "item"
      })) < 0) {
        if (_this.props.onDropdownBlur) {
          _this.props.onDropdownBlur();
        }

        _this.collapse();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculateListHeight", function (itemHeight, visibleItems) {
      return "".concat(Math.abs(visibleItems) * itemHeight / BASE_FONT_SIZE, "rem");
    });

    _defineProperty(_assertThisInitialized(_this), "setListMaxHeight", function (itemHeight) {
      var maxVisibleItems = _this.props.maxVisibleItems;

      if (maxVisibleItems) {
        _this.setState({
          maxListHeight: _this.calculateListHeight(itemHeight, maxVisibleItems)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getItemForCurrentValue", function (value) {
      // eslint-disable-next-line no-undefined
      if (value === null || value === undefined) {
        return;
      }

      return _this.props.items.find(function (item) {
        return item.value === value;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectItem", function (selectedItem) {
      if (!_this.state.expanded) {
        return;
      }

      var value = _this.isTypeaheadMode ? selectedItem.label : selectedItem.value;

      if (_this.isTypeaheadMode) {
        _this.handleFilter(value);

        _this.setState({
          isClearButtonVisible: true
        });
      }

      _this.setState({
        value: value
      });

      if (_this.props.onItemClicked) {
        _this.props.onItemClicked(selectedItem);
      }

      if (_this.props.onValueChanged) {
        _this.props.onValueChanged(selectedItem.value);
      }

      _this.collapse();
    });

    _defineProperty(_assertThisInitialized(_this), "navigateToNextItem", function (direction) {
      var _this$props$items2 = _this.props.items,
          items = _this$props$items2 === void 0 ? [] : _this$props$items2;
      var _this$state = _this.state,
          index = _this$state.index,
          expanded = _this$state.expanded;

      if (!expanded) {
        _this.expand();

        return;
      }

      var isLastOrFirstSelected = direction === "down" && index >= items.length - 1 || direction === "up" && index <= 0;

      if (isLastOrFirstSelected) {
        return;
      }

      var nextIndex = direction === "down" ? (index + 1) % _this.state.filteredItems.length : (index - 1 + _this.state.filteredItems.length) % _this.state.filteredItems.length;

      _this.setState({
        index: nextIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleHomePress", function () {
      _this.setState({
        index: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEndPress", function () {
      var _this$props$items3 = _this.props.items,
          items = _this$props$items3 === void 0 ? [] : _this$props$items3;

      _this.setState({
        index: items.length - 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabPress", function () {
      if (!_this.state.expanded) {
        return;
      }

      _this.collapse();
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnterPress", function () {
      var items = _this.state.filteredItems;
      var _this$state2 = _this.state,
          index = _this$state2.index,
          expanded = _this$state2.expanded;

      if (!expanded || index < 0) {
        _this.toggleExpand();

        return;
      }

      if (!_this.selectedLinkRef.current) {
        _this.selectItem(items[index]);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$filterContainer;

      var isFilterInFocus = (_this$filterContainer = _this.filterContainerRef.current) === null || _this$filterContainer === void 0 ? void 0 : _this$filterContainer.contains(e.target);

      switch (e.key) {
        case "Escape":
          _this.handleTabPress();

          break;

        case "ArrowUp":
          _this.navigateToNextItem("up");

          break;

        case "ArrowDown":
          _this.navigateToNextItem("down");

          break;

        case "Home":
          _this.handleHomePress();

          break;

        case "End":
          _this.handleEndPress();

          break;

        case "Enter":
          _this.handleEnterPress();

          break;

        case " ":
          if (isFilterInFocus) {
            break;
          }

          _this.toggleExpand();

      } // Prevent default behavior for all keys except for Tab or Enter if the filter is not in focus
      // as an example: this will stop the document from scrolling as
      // arrow-up/down is pressed.
      // Special case is "Enter" - for that key we want default behaviour
      // only when the items are links (A tag element) so the links will work
      // on "Enter" key press.


      if (e.key !== "Tab" && e.key !== "Enter" && !isFilterInFocus || e.key === "Enter" && !_this.selectedLinkRef.current) {
        e.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeaderComponent", function (labelOptions, expanded, a11yHeaderProps) {
      var label = labelOptions.label,
          customLabel = labelOptions.customLabel;

      if (_this.isTypeaheadMode) {
        return _this.renderTypeahead();
      }

      if (_this.props.renderHeader) {
        return _this.props.renderHeader(label, expanded, _this.toggleExpand, _this.expandButtonId);
      }

      var labelValue = customLabel !== null && customLabel !== void 0 ? customLabel : label;
      return /*#__PURE__*/React.createElement(DropdownHeader, {
        buttonRef: _this.toggleButtonRef,
        a11yHeaderProps: a11yHeaderProps,
        text: labelValue,
        toggleExpand: _this.toggleExpand,
        getClassName: _this.getClassName
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilter", function (filterValue) {
      if (!filterValue.length) {
        _this.setState({
          filteredItems: _this.props.items
        });

        return;
      }

      if (_this.props.filterFunction) {
        var filteredItems = _this.props.filterFunction(_this.props.items, filterValue);

        _this.setState({
          filteredItems: filteredItems
        });
      }
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "dropDownItems",
    get: function get() {
      return this.isTypeaheadMode ? this.state.filteredItems : this.props.items;
    }
  }, {
    key: "isTypeaheadMode",
    get: function get() {
      return Boolean(this.props.typeaheadMode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _focusedItem$value;

      var _this$props = this.props,
          block = _this$props.block,
          items = _this$props.items,
          placeholder = _this$props.placeholder,
          size = _this$props.size,
          labeledBy = _this$props.labeledBy,
          ariaLabel = _this$props.ariaLabel,
          maxVisibleItems = _this$props.maxVisibleItems,
          withCheckmark = _this$props.withCheckmark,
          renderItem = _this$props.renderItem,
          renderFilter = _this$props.renderFilter;
      var _this$state3 = this.state,
          expanded = _this$state3.expanded,
          maxListHeight = _this$state3.maxListHeight,
          value = _this$state3.value,
          index = _this$state3.index;
      var currentItem = this.getItemForCurrentValue(value);
      var label = placeholder;
      var customLabel;

      if (currentItem) {
        label = currentItem.label;
        customLabel = currentItem.customLabel;
      } // if no values and hrefs - this is links and should be presented in modal dialog


      var isLinks = items.every(function (item) {
        return !item.value && item.href;
      });
      var focusedItem = this.props.items.find(function (item, ind) {
        return ind === _this2.state.index;
      });
      var shouldUseAriaLabelledBy = !ariaLabel && !isLinks;
      var ariaLabelledByText = labeledBy || "headerText";

      var a11yHeaderProps = _objectSpread(_objectSpread(_objectSpread({
        id: this.expandButtonId,
        tabIndex: 0,
        "aria-haspopup": isLinks ? "true" : "listbox",
        "aria-expanded": expanded
      }, ariaLabel && {
        "aria-label": ariaLabel
      }), shouldUseAriaLabelledBy && {
        "aria-labelledby": ariaLabelledByText
      }), !isLinks && {
        "aria-activedescendant": focusedItem ? (_focusedItem$value = focusedItem.value) === null || _focusedItem$value === void 0 ? void 0 : _focusedItem$value.toString() : ""
      });

      var a11yListProps = _objectSpread(_objectSpread({}, !isLinks && {
        role: "listbox"
      }), {}, {
        tabIndex: isLinks ? -1 : 0
      });

      var getListStyles = function getListStyles() {
        if (maxVisibleItems) {
          return {
            maxHeight: maxListHeight
          };
        } // eslint-disable-next-line no-undefined


        return undefined;
      };

      var customDataItems = items.map(function (item) {
        return {
          value: item.value,
          href: item.href,
          label: item.label
        };
      });
      var labelOptions = {
        label: label,
        customLabel: customLabel
      };

      if (!this.state.isClearButtonVisible && this.state.value) {
        this.setState({
          isClearButtonVisible: true
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        tabIndex: this.props.tabIndex,
        role: "listbox",
        className: this.getClassName({
          modifiers: classNames(_defineProperty({
            block: block
          }, size, true)),
          states: classNames({
            expanded: expanded
          }),
          className: this.props.className
        }),
        onBlur: this.maybeCollapse // Rehyratable props
        ,
        "data-block": JSON.stringify(block),
        "data-items": JSON.stringify(customDataItems),
        "data-placeholder": JSON.stringify(placeholder),
        "data-rehydratable": getRehydratableName(Dropdown.displayName),
        "data-size": JSON.stringify(size),
        "data-value": JSON.stringify(value),
        onKeyDown: this.onKeyDown,
        id: this.state.id
      }, this.renderHeaderComponent(labelOptions, expanded, a11yHeaderProps), this.dropDownItems.length > 0 && this.state.expanded && /*#__PURE__*/React.createElement("div", {
        id: this.props.dropdownMenuId,
        "aria-labelledby": this.expandButtonId,
        className: this.getClassName({
          descendantName: "listWrapper"
        })
      }, renderFilter && !this.isTypeaheadMode && renderFilter(this.collapse, this.filterContainerRef, this.filterInputId), /*#__PURE__*/React.createElement("ul", _extends({
        ref: this.ulRef,
        className: this.getClassName({
          descendantName: "items",
          modifiers: classNames({
            scroll: maxVisibleItems,
            links: isLinks
          })
        })
      }, a11yListProps, {
        style: getListStyles()
      }), this.dropDownItems.map(function (item, itemIndex) {
        var isSelected = value === item.value || _this2.isTypeaheadMode && value === item.label; // measure height only for first item to prevent perfomance issues & only if scroll needed

        var shouldMeasureHeight = itemIndex === 0 && maxVisibleItems;
        var itemProps = {
          getClassName: _this2.getClassName,
          getItemHeight: shouldMeasureHeight ? _this2.setListMaxHeight : // eslint-disable-next-line no-undefined
          undefined,
          isFocused: index === itemIndex,
          isSelected: isSelected,
          item: item,
          linkRef: isSelected && item.href ? _this2.selectedLinkRef : // eslint-disable-next-line no-undefined
          undefined,
          onBlur: _this2.maybeCollapse,
          onItemClicked: _this2.selectItem,
          withCheckmark: withCheckmark
        };
        return renderItem ? renderItem(itemProps, itemIndex) : /*#__PURE__*/React.createElement(DropdownItem, _extends({}, itemProps, {
          key: item.label
        }));
      }))));
    }
  }]);

  return Dropdown;
}(React.Component);

_defineProperty(Dropdown, "displayName", "Dropdown");

_defineProperty(Dropdown, "defaultProps", {
  block: true,
  size: "large",
  items: []
});

_defineProperty(Dropdown, "rehydrator", rehydrator);

export default Dropdown;